import { useTranslation } from 'react-i18next';
import { Typography, Card, CardContent, Box, IconButton } from '@mui/material';
import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { GridColDef } from '@mui/x-data-grid';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { showLabel } from '@/utils/helper';
import { useGetRuleListQuery } from '@/api/task/ruleApiSlice';
import LocalDataGrid from '@/common/components/dataGrid/LocalDataGrid';
import { TaskRuleDescriptionDTO } from '@/api/DTO/task/rule.interface';
import dayjs from 'dayjs';
import { DISPLAY_DATETIME_12H_FORMAT } from '@/utils/dateHelper';
import { TitleType } from '@/api/enum/common.enum';

export interface Grid {
	updatedAt?: string;
}

export default function RuleSummaryPage() {
	const { t } = useTranslation();

	const { data: propertySummary, isSuccess: isGetPropertySummarySuccess } =
		useGetRuleListQuery(null, {
			refetchOnMountOrArgChange: true,
		});

	const transformResponse = useCallback(
		(response?: TaskRuleDescriptionDTO[]) => {
			console.log(response);
			if (response == null) return;
			const newResponse: Grid[] = [];
			response.forEach((item) => {
				newResponse.push({
					...item,
					updatedAt: !item.updatedAt
						? '-'
						: dayjs(item.updatedAt)
								.locale('en')
								.format(DISPLAY_DATETIME_12H_FORMAT),
				});
			});
			return newResponse;
		},
		[]
	);
	const columns: GridColDef[] = [
		{
			field: 'titleZh',
			headerName: t('ruleList.titleType'),
			flex: 21,
		},
		{
			field: 'updatedAt',
			headerName: t('ruleList.updateTime'),
			flex: 15,
		},
		{
			field: 'edit',
			headerName: '',
			width: 68,
			renderCell: (params) => (
				<Link to={`/task-manage/rule-list/info/${params.id}`}>
					<IconButton color='primary'>
						<VisibilityOutlinedIcon />
					</IconButton>
				</Link>
			),
		},
	];

	return (
		<>
			<Box display='flex' justifyContent='space-between'>
				<Typography variant='h4'>{t('drawerListItems.ruleList')}</Typography>
			</Box>

			<Card sx={{ marginTop: 3 }}>
				<CardContent>
					<Box marginTop={2}>
						<LocalDataGrid
							rows={transformResponse(propertySummary?.data) ?? []}
							columns={columns}
							rowCount={0}
							getRowId={(row) => row.id}
							pagination={false}
						/>
					</Box>
				</CardContent>
			</Card>
		</>
	);
}
